<template>
  <!-- 贷款利率 -->
  <div class="table_container">
    <table>
      <tbody align="center">
        <tr>
          <th width="175px"></th>
          <th colspan="12">{{ `${queryParams.years}年` }}</th>
        </tr>
        <tr>
          <th>月度</th>
          <th v-for="(item, index) in monthList" :key="index">
            {{ item.month }}
          </th>
        </tr>
        <tr>
          <th>利率(%)</th>
          <td
            v-for="(item, index) in monthList"
            :key="index"
            @click="handleColumn(item.loanRateField)"
          >
            <el-input
              v-if="editField === item.loanRateField"
              id="focusRef"
              v-model="form[item.loanRateField]"
              size="mini"
              style="width: 100%"
              @blur="confirmEdit"
              @keyup.enter.native="confirmEdit"
            ></el-input>
            <span v-else>
              {{ form[item.loanRateField] }}
            </span>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { addOrUpdateLoanRateApi } from "@/api/saleTaskCollection";

export default {
  data() {
    return {
      queryParams: {},
      form: this.getForm(),
      editField: "", // 编辑单元格
      monthList: [
        {
          month: "1月",
          loanRateField: "oneRate"
        },
        {
          month: "2月",
          loanRateField: "twoRate"
        },
        {
          month: "3月",
          loanRateField: "threeRate"
        },
        {
          month: "4月",
          loanRateField: "fourRate"
        },
        {
          month: "5月",
          loanRateField: "fiveRate"
        },
        {
          month: "6月",
          loanRateField: "sixRate"
        },
        {
          month: "7月",
          loanRateField: "sevenRate"
        },
        {
          month: "8月",
          loanRateField: "eightRate"
        },
        {
          month: "9月",
          loanRateField: "nineRate"
        },
        {
          month: "10月",
          loanRateField: "tenRate"
        },
        {
          month: "11月",
          loanRateField: "elevenRate"
        },
        {
          month: "12月",
          loanRateField: "twelveRate"
        }
      ] // 月度
    };
  },
  methods: {
    init(data, queryParams = {}) {
      this.queryParams = { ...queryParams };
      this.form = this.getForm(data || {});
    },
    // 获取表单数据
    getForm(data = {}) {
      return {
        id: data.id || "",
        oneRate: data.oneRate ?? undefined,
        twoRate: data.twoRate ?? undefined,
        threeRate: data.threeRate ?? undefined,
        fourRate: data.fourRate ?? undefined,
        fiveRate: data.fiveRate ?? undefined,
        sixRate: data.sixRate ?? undefined,
        sevenRate: data.sevenRate ?? undefined,
        eightRate: data.eightRate ?? undefined,
        nineRate: data.nineRate ?? undefined,
        tenRate: data.tenRate ?? undefined,
        elevenRate: data.elevenRate ?? undefined,
        twelveRate: data.twelveRate ?? undefined
      };
    },
    // 点击单元格编辑
    handleColumn(field) {
      this.editField = field;
      this.$nextTick(() => {
        document.querySelector("#focusRef")?.focus();
        document.querySelector("#focusRef .el-input__inner")?.focus();
      });
    },
    // 确认编辑
    confirmEdit() {
      this.editField = "";
    },
    // 保存
    async handleSave(callBack) {
      try {
        let submitData = JSON.parse(
          JSON.stringify({ ...this.queryParams, ...this.form })
        );
        const res = await addOrUpdateLoanRateApi(submitData);
        if (res.status == 0) {
          this.$DonMessage.success("操作成功！");
          this.form.id = res.data.id;
          callBack();
        } else {
          this.$DonMessage.error(res.message);
        }
      } catch (error) {
        console.error(error);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.table_container {
  padding: 0 18px 0 50px;

  table {
    border-collapse: collapse;
    table-layout: fixed;
    width: 100%;
  }
  th,
  td {
    border: 1px solid #dcdfe6;
    padding: 4px 12px;
    height: 40px;
    font-size: 14px;
    word-break: break-all;
  }
  th {
    background-color: #f2f2f2;
  }
  .number_input {
    width: 100%;
    padding: 0;
    ::v-deep .el-input__inner {
      padding: 0 8px;
    }
  }
}
</style>
